// extracted by mini-css-extract-plugin
module.exports = {"caption":"caption_caption__1sYXV","captionRight":"caption_captionRight__22Smb","captionCenter":"caption_captionCenter__qKZ7-","captionGreen":"caption_captionGreen__1NL-9"};